export default __webpack_public_path__ + "static/media/mustardsauce@3x.fd928628.jpg";